import { render, staticRenderFns } from "./WaitingListTable.vue?vue&type=template&id=78772242&scoped=true"
import script from "./WaitingListTable.vue?vue&type=script&lang=js"
export * from "./WaitingListTable.vue?vue&type=script&lang=js"
import style0 from "./WaitingListTable.vue?vue&type=style&index=0&id=78772242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78772242",
  null
  
)

export default component.exports